import { breakpoints } from '@brig/theme/tokens';
import { useSyncExternalStore } from 'react';

/** Below the desktop width the game screen is "compact": board first, panels in sheets (§13). */
export const COMPACT_QUERY = `(max-width: ${breakpoints.desktop - 1}px)`;

function subscribe(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const list = window.matchMedia(COMPACT_QUERY);
  list.addEventListener('change', onChange);
  return () => {
    list.removeEventListener('change', onChange);
  };
}

/** Whether the screen is phone- or tablet-sized. jsdom (no matchMedia) counts as wide. */
export function useCompact(): boolean {
  return useSyncExternalStore(subscribe, () =>
    typeof window.matchMedia === 'function' ? window.matchMedia(COMPACT_QUERY).matches : false,
  );
}

const ONCE_KEY = 'brig.once.v1';

/** One-time hints already shown on this device (U-VIEW-06). */
export function seen(name: string): boolean {
  try {
    return (JSON.parse(localStorage.getItem(ONCE_KEY) ?? '[]') as string[]).includes(name);
  } catch {
    return true;
  }
}

export function markSeen(name: string): void {
  try {
    const list = JSON.parse(localStorage.getItem(ONCE_KEY) ?? '[]') as string[];
    localStorage.setItem(ONCE_KEY, JSON.stringify([...new Set([...list, name])]));
  } catch {
    // Without storage the hint may show again next time; that is all.
  }
}
